import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mainCategory'
})
export class MainCategoryPipe implements PipeTransform {
  transform(categories: any[]): any | null {
    if (!Array.isArray(categories)) return null;
    const validCategory = categories.find(cat => cat?.name?.toLowerCase() !== 'otros');
    return validCategory || categories[0] || null;
  }
}
